import { AccountInfo } from '@azure/msal-browser';
import { create, StateCreator } from 'zustand';
import { createJSONStorage, persist, StateStorage } from 'zustand/middleware';
import {
  customExtensionStorage,
  shouldUseExtensionStorage,
} from './extension-storage';

const AUTH_STORE_STORAGE_KEY = 'auth.store';

interface AuthStore {
  setAccount: (account: AccountInfo | null) => void;
  account: AccountInfo | null;
  isAuthenticated: boolean;
}

const stateCreator: StateCreator<AuthStore> = set => ({
  account: null,
  isAuthenticated: false,
  setAccount: account => {
    set({ account, isAuthenticated: !!account?.idToken });
  },
});

export const useAuthStore = create<AuthStore>()(
  persist(stateCreator, {
    name: AUTH_STORE_STORAGE_KEY,
    storage: createJSONStorage(() =>
      shouldUseExtensionStorage
        ? (customExtensionStorage as StateStorage)
        : localStorage
    ),
  })
);
